import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationHistory = ({ verifications }) => {
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-lg shadow-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Icon name="History" size={24} color="var(--color-primary)" />
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Verifizierungsverlauf
          </h2>
        </div>
        <span className="text-sm text-muted-foreground">
          Letzte {verifications?.length} Prüfungen
        </span>
      </div>
      <div className="space-y-3">
        {verifications?.length === 0 ? (
          <div className="text-center py-12">
            <Icon name="FileSearch" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4 opacity-50" />
            <p className="text-muted-foreground">Noch keine Verifizierungen durchgeführt</p>
          </div>
        ) : (
          verifications?.map((verification, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-smooth"
            >
              <div className="flex items-center gap-4 flex-1">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  verification?.isValid ? 'bg-success/10' : 'bg-error/10'
                }`}>
                  <Icon
                    name={verification?.isValid ? 'CheckCircle2' : 'XCircle'}
                    size={20}
                    color={verification?.isValid ? 'var(--color-success)' : 'var(--color-error)'}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground truncate">
                    {verification?.customerName}
                  </p>
                  <p className="text-xs text-muted-foreground font-mono">
                    {verification?.voucherCode}
                  </p>
                </div>
              </div>
              <div className="text-right ml-4">
                <p className="text-xs text-muted-foreground">
                  {formatTimestamp(verification?.timestamp)}
                </p>
                {verification?.isValid && (
                  <p className="text-xs font-medium text-success mt-1">
                    {verification?.premiumAmount}
                  </p>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default VerificationHistory;